import Alert from "@/components/core/alert";
import { ProgressBar } from "@/components/core/progress-bar";
import { Content } from "@/components/layouts/content";
import CaseFilingAttachments, { type CaseFilingAttachmentRef } from "@/features/case-evaluation/case-filing-attachments";
import CaseFilingEvidence, { type CaseFilingEvidenceRef } from "@/features/case-evaluation/case-filing-evidence";
import CaseFilingInfo, { type CaseFilingInfoRef } from "@/features/case-evaluation/case-filing-info";
import CaseFiling, { CaseFilingStep } from "@/features/case-evaluation/components/case-filing";
import { createFileRoute } from "@tanstack/react-router";
import { useRef, useState } from "react";

export const Route = createFileRoute("/_backoffice/case-filings_/create")({
	component: RouteComponent,
});

function RouteComponent() {
	const caseFilingInfoRef = useRef<CaseFilingInfoRef>(null);
	const caseFilingAttachmentRef = useRef<CaseFilingAttachmentRef>(null);
	const caseFilingEvidenceRef = useRef<CaseFilingEvidenceRef>(null);

	const [data, setData] = useState<string | null>(null);
	const [caseRecordId, setCaseRecordId] = useState<string | null>(null);

	const handleValidateStep = async (step: number): Promise<boolean> => {
		if (step === 1) {
			const response = await caseFilingInfoRef.current?.handleSubmit();
			if (response) {
				setData(response);
				setCaseRecordId(response.id);
			}
			return response ?? false;
		}

		if (step === 2) {
			const attachmentResponse = await caseFilingAttachmentRef.current?.handleAttachmentSubmit();
			console.log(attachmentResponse, "step 2 attachment response");

			return attachmentResponse ?? false;
		}

		if (step === 3) {
			const evidenceResponse = await caseFilingEvidenceRef.current?.handleEvidenceSubmit();
			console.log(evidenceResponse, "step 3 evidence response");

			return evidenceResponse ?? false;
		}

		return true;
	};

	const handleNext = (step: number) => {
		console.log("Moving to step", step);
	};

	return (
		<Content pageName="New Case Filing">
			<div className="flex flex-col w-full max-w-base p-6">
				<div className="mb-20">
					<CaseFiling onNext={handleNext} onValidateStep={handleValidateStep} caseRecordId={caseRecordId}>
						<CaseFilingStep step={1} title="Step 1" subtitle="Case Filing">
							<div className="flex flex-col w-full">
								<CaseFilingInfo ref={caseFilingInfoRef} data={undefined} />
							</div>
						</CaseFilingStep>

						<CaseFilingStep step={2} title="Step 2" subtitle="Case Complaints & Annexes">
							<div className="flex flex-col w-full">
								<CaseFilingAttachments ref={caseFilingAttachmentRef} data={data} />
							</div>
							<div className="flex w-[70px]">
								{/*
                  color=primary (processing)
                  color=success (done process)
                  color=danger (error)
                */}
								{/* <ProgressBar value={75} max={100} label="Uploading" size="md" color="primary" /> */}
							</div>
						</CaseFilingStep>

						<CaseFilingStep step={3} title="Step 3" subtitle="Pieces of Evidence">
							<div className="flex flex-col w-full">
								<CaseFilingEvidence ref={caseFilingEvidenceRef} data={data} />
							</div>
						</CaseFilingStep>

						<CaseFilingStep step={4} title="Step 4" subtitle="Submit Case Filing">
							<div className="flex flex-col w-full">
								<Alert type="info" allowClose={false} title="Confirm Deletion">
									Are you sure you want to submit this case?
								</Alert>
							</div>
						</CaseFilingStep>
					</CaseFiling>
				</div>
			</div>
		</Content>
	);
}
